<div class="p-4 flex-col flex gap-4">
    <!-- Header -->
    <div class="flex flex-col gap-1">
        <h3>
            <i class="ci ci-air text-teal-600 font-bold"></i> 空氣品質
        </h3>
        <div class="text-xs text-slate-500 flex items-center gap-1 pl-6">
            <i class="pi pi-clock"></i>
            採樣時間 : {{ data()?.time || '-' }}
        </div>
    </div>

    <!-- Data Grid -->
    <div class="grid grid-cols-2 gap-3">
        <!-- Temperature -->
        <div [ngClass]="data()?.temperature?.isAlarm ? 'bg-red-50 border-red-500' : 'bg-white border-slate-200'"
            class="p-4 rounded-lg shadow-sm flex flex-col justify-center min-h-[90px] border">
            <div class="flex items-center gap-2 mb-1" [ngClass]="data()?.temperature?.isAlarm ? 'text-red-500 font-bold' : 'text-slate-400'">
                <i class="ci ci-temp text-sm"></i>
                <span class="text-sm">溫度</span>
            </div>
            <div class="font-bold text-3xl flex items-baseline gap-1" [ngClass]="data()?.temperature?.isAlarm ? 'text-red-500' : 'text-slate-800'">
                {{ data()?.temperature?.value || 0 }}
                <span class="text-base font-bold" [ngClass]="data()?.temperature?.isAlarm ? 'text-red-400' : 'text-slate-600'">°C</span>
            </div>
        </div>

        <!-- Humidity -->
        <div [ngClass]="data()?.humidity?.isAlarm ? 'bg-red-50 border-red-500' : 'bg-white border-slate-200'"
            class="p-4 rounded-lg shadow-sm flex flex-col justify-center min-h-[90px] border">
            <div class="flex items-center gap-2 mb-1" [ngClass]="data()?.humidity?.isAlarm ? 'text-red-500 font-bold' : 'text-slate-400'">
                <i class="ci ci-humi text-sm"></i>
                <span class="text-sm">濕度</span>
            </div>
            <div class="font-bold text-3xl flex items-baseline gap-1" [ngClass]="data()?.humidity?.isAlarm ? 'text-red-500' : 'text-slate-800'">
                {{ data()?.humidity?.value || 0 }}
                <span class="text-base font-bold" [ngClass]="data()?.humidity?.isAlarm ? 'text-red-400' : 'text-slate-600'">%</span>
            </div>
        </div>

        <!-- CO2 -->
        <div [ngClass]="data()?.co2?.isAlarm ? 'bg-red-50 border-red-500' : 'bg-white border-slate-200'"
            class="p-4 rounded-lg shadow-sm flex flex-col justify-center min-h-[90px] border">
            <div class="flex items-center gap-2 mb-1" [ngClass]="data()?.co2?.isAlarm ? 'text-red-500 font-bold' : 'text-slate-400'">
                <i class="ci ci-co2 text-sm"></i>
                <span class="text-sm">二氧化碳</span>
            </div>
            <div class="font-bold text-3xl flex items-baseline gap-1" [ngClass]="data()?.co2?.isAlarm ? 'text-red-500' : 'text-slate-800'">
                {{ data()?.co2?.value || 0 }}
                <span class="text-base font-bold" [ngClass]="data()?.co2?.isAlarm ? 'text-red-400' : 'text-slate-600'">ppm</span>
            </div>
        </div>

        <!-- PM2.5 -->
        <div [ngClass]="data()?.pm25?.isAlarm ? 'bg-red-50 border-red-500' : 'bg-white border-slate-200'"
            class="p-4 rounded-lg shadow-sm flex flex-col justify-center min-h-[90px] border">
            <div class="flex items-center gap-2 mb-1" [ngClass]="data()?.pm25?.isAlarm ? 'text-red-500 font-bold' : 'text-slate-400'">
                <i class="ci ci-pm25 text-sm"></i>
                <span class="text-sm">PM2.5</span>
            </div>
            <div class="font-bold text-3xl flex items-baseline gap-1" [ngClass]="data()?.pm25?.isAlarm ? 'text-red-500' : 'text-slate-800'">
                {{ data()?.pm25?.value || 0 }}
                <span class="text-base font-bold" [ngClass]="data()?.pm25?.isAlarm ? 'text-red-400' : 'text-slate-600'">μg/m³</span>
            </div>
        </div>
    </div>
</div>